import { Icon, IconButton } from "@mui/material";
import MDBox from "components/MDBox";
import UiInput from "components/base/UiInput";
import UiTypography from "components/base/UiTypography";
import { ProposalStage } from "generated/graphql";
import useCustomUpdateProposalStage from "hooks/proposals/useCustomUpdateProposalStage";
import { useCallback, useState } from "react";
import { useDraftContext } from "./DraftContext";
import { draftColors } from "./draftDesignTokens";

type EditableStageNameProps = {
  stage: ProposalStage;
};

export default function EditableStageName({ stage }: EditableStageNameProps) {
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(stage.name || "");
  const [updateStage] = useCustomUpdateProposalStage();
  const { isReadOnly } = useDraftContext();

  const handleSave = useCallback(async () => {
    const trimmed = name.trim();
    if (trimmed && trimmed !== stage.name) {
      await updateStage({ variables: { id: stage.id, name: trimmed } });
    } else {
      setName(stage.name || "");
    }
    setEditing(false);
  }, [name, stage.name, stage.id, updateStage]);

  if (editing) {
    return (
      <UiInput
        value={name}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
        onBlur={handleSave}
        onKeyDown={(e: React.KeyboardEvent) => {
          if (e.key === "Enter") handleSave();
          if (e.key === "Escape") {
            setName(stage.name || "");
            setEditing(false);
          }
        }}
        autoFocus
        sx={{ fontSize: "18px", fontWeight: 700, maxWidth: "300px" }}
      />
    );
  }

  return (
    <>
      <UiTypography uiVariant="heading-lg" sx={{ fontSize: "18px" }}>
        Job: {stage.name}
      </UiTypography>
      {!!stage.name && !isReadOnly && (
        <IconButton
          size="small"
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            setEditing(true);
          }}
          sx={{ p: "2px" }}
        >
          <Icon sx={{ fontSize: "16px !important", color: draftColors.textSecondary }}>edit</Icon>
        </IconButton>
      )}
    </>
  );
}
